module.exports = __webpack_public_path__ + "static/media/mcpayment.3eb4978f.svg";